export * from './events';
export * from './message';
export * from './pagePath';

export const TOKEN = 'token';

export const OPENID_KEY = 'openIdKey';

export const SEARCH_VALUE = 'search_value';

export const SKU_SPLITER = '*';

export const LIMIT = 10;

export const LIMIT_MAX = 99;

export const TIME_OUT = 6000;

/** 新用户的临时分销信息 */
export const NEW_USER_TEMP_SHARE_DISTRIBUTOR = '__NEW_USER__TEMP_SHARE_DISTRIBUTOR___';

/** 自定义页面弹窗缓存 */
export const CUSTOM_PAGE_ACTIVITY_MODAL = '__CUSTOM_PAGE_ACTIVITY_MODAL__';
